import DeleteIcon from '@mui/icons-material/Delete';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Tooltip from '@mui/material/Tooltip';
import { FC } from 'react';
import { GroupPolicy } from '@bom-nextgen-keycloak/models';
import {
  StyledTableCellHead,
  TableFormFooter,
} from '@bom-nextgen-keycloak/web/shared/ui';
import { TableContainer } from './GroupTableForm2.styled';

type GroupTableFormProps = {
  data: GroupPolicy[];
  disabled?: boolean;
  onRemove: (item: GroupPolicy) => void;
  onSelect: (checked: boolean, id: string) => void;
};

const GroupTableForm2: FC<GroupTableFormProps> = ({
  data,
  disabled = false,
  onRemove,
  onSelect,
}) => {
  const totalRecord = data.length;

  return (
    <Paper>
      <TableContainer>
        <Table aria-label="group table" stickyHeader>
          <TableHead>
            <TableRow>
              <StyledTableCellHead>Group name</StyledTableCellHead>
              <StyledTableCellHead align="center" sx={{ width: '150px' }}>
                Extend to children
              </StyledTableCellHead>
              <StyledTableCellHead align="center" sx={{ width: '85px' }}>
                Actions
              </StyledTableCellHead>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((item) => {
              const { extendChildren = false, id, path = '' } = item;

              return (
                <TableRow key={id}>
                  <TableCell>{path}</TableCell>
                  <TableCell align="center">
                    <Checkbox
                      checked={extendChildren}
                      disabled={disabled}
                      onChange={(event) => onSelect(event.target.checked, id)}
                      size="small"
                    />
                  </TableCell>
                  <TableCell align="center">
                    <Tooltip title="Remove group">
                      <IconButton
                        aria-label="delete"
                        onClick={() => onRemove(item)}
                        size="small"
                      >
                        <DeleteIcon fontSize="inherit" />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TableFormFooter>
        <b>{`${totalRecord} group${totalRecord > 1 ? 's' : ''}`}</b> selected
      </TableFormFooter>
    </Paper>
  );
};

export { GroupTableForm2 };
